import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ServiceChipProps {
  service: string;
  onRemove: () => void;
  className?: string;
}

export const ServiceChip = ({ service, onRemove, className }: ServiceChipProps) => {
  return (
    <div 
      className={cn(
        "inline-flex items-center gap-2 bg-je-red/10 text-je-red px-3 py-1.5 rounded-full text-sm font-medium border border-je-red/20 transition-all duration-200 hover:bg-je-red/20",
        className
      )}
      role="listitem"
    >
      <span>{service}</span>
      <button
        type="button"
        onClick={onRemove}
        className="w-4 h-4 rounded-full bg-je-red/20 hover:bg-je-red/30 flex items-center justify-center transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-je-red/50"
        aria-label={`Retirer ${service}`}
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
};